module.exports = __webpack_public_path__ + "static/media/iconVideoLastStepHorizontalDone.933955cb.svg";